import { createApi } from '@reduxjs/toolkit/query/react';
import PaginatedResult from '../../types/paginatedResult';
import { buildPaginatedQuery, safeBaseQuery } from './functions';
import { CompanyCreateDto, CompanyDto } from '../../types/company';
import { CompanyLegalForm, CompanyScopeType, CompanySize, CompanyStatus, Country } from '../../constants/enums';

export interface CompanyFilters {
    name?: string;
    country?: Country[];
    mainLanguageId?: number[];
    mainScope?: CompanyScopeType[];
    legalForm?: CompanyLegalForm[];
    size?: CompanySize[];
    status?: CompanyStatus[];
    ic?: string;
    vat?: string;
    zipCode?: string;
    county?: string;
    district?: string;
    cityDistrict?: string;
    municipality?: string;
    village?: string;
    street?: string;
    address?: string;
    addressDetails?: string;
    addressDetails2?: string;
}

const company = createApi({
    reducerPath: 'apiCompany',
    baseQuery: safeBaseQuery('company'),
    endpoints: (builder) => ({
        getCompanyById: builder.query<CompanyDto, number>({
            query: (id) => `/${id}`,
        }),
        getCompanies: builder.query<
            PaginatedResult<CompanyDto>,
            {
                filters?: CompanyFilters;
                page?: number;
                pageSize?: number;
                orderBy?: string;
                asc?: boolean;
            }
        >({
            query: (args = {}) => buildPaginatedQuery<CompanyFilters>(args),
        }),
        createCompany: builder.mutation<CompanyDto, CompanyCreateDto>({
            query: (newCompany) => ({
                url: '/',
                method: 'POST',
                body: newCompany,
            }),
        }),
    }),
});

export const { useGetCompaniesQuery, useGetCompanyByIdQuery, useLazyGetCompanyByIdQuery, useCreateCompanyMutation } =
    company;
export default company;
